import { useEffect } from 'react';

export function useSeo({ title, description }) {
  useEffect(() => {
    // Title structure rule:
    // Forside: "Skatunderlup"
    // Undersider: "[Titel på underside] - Skatunderlup"
    const fullTitle = title && title !== 'Forside'
      ? `${title} - Skatunderlup`
      : 'Skatunderlup';

    document.title = fullTitle;

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }
  }, [title, description]);
}
